Vue.filter('capitalize', function (value) {
    if (!value) return ''

    return _.upperFirst(value)
})

Vue.filter('titleCase', function (value) {
    if (!value) return ''

    return _.startCase(_.toLower(value))
})